import { Formik } from 'formik';
import { useSnackbar } from 'notistack';
import eduBudgetValidationSchema from './eduBudgetValidationSchema';
import { useAuth } from '../../../auth';
import { apiClient } from 'api-client';
import EduBudgetRequestForm from './EduBudgetRequestForm';

const withTime = (value, hours = 10, minutes = 0, seconds = 0, ms = 0) => {
  if (!value) return null;

  const date = new Date(value);
  date.setHours(hours, minutes, seconds, ms);
  return date;
};

const EduBudgetRequestFormContainer = ({
  userAvailableEduBudget,
  preliminaryEduBudget,
  setPreliminaryEduBudget,
}) => {
  const { enqueueSnackbar } = useSnackbar();
  const { getToken } = useAuth();

  return (
    <Formik
      enableReinitialize
      initialErrors={[]}
      validationSchema={eduBudgetValidationSchema}
      initialValues={{}}
      onSubmit={async (values, { resetForm }) => {
        if (values.totalAmount > userAvailableEduBudget) {
          enqueueSnackbar('Sorry, there is not enough education budget for this request', {
            variant: 'error',
          });
          return;
        }

        try {
          const result = await apiClient('POST', '/requests/edu-budget', getToken, {
            type: values.type,
            title: values.title,
            description: values.description,
            link: values.link,
            totalAmount: values.totalAmount,
            startDate: values.startDate ? withTime(values.startDate, 10).toISOString() : null,
            endDate: values.endDate ? withTime(values.endDate, 10).toISOString() : null,
            budgetCosts: values.budgetCosts,
          });

          if (result?.status !== 'OK') throw new Error(result?.message || 'Request failed');

          setPreliminaryEduBudget(preliminaryEduBudget + Number(values.totalAmount));
          enqueueSnackbar('Education budget request successfully submitted', {
            variant: 'success',
          });
          resetForm();
        } catch (err) {
          enqueueSnackbar(err.message || 'Error when submitting education budget request', {
            variant: 'error',
          });
        }
      }}
    >
      {form => <EduBudgetRequestForm formProps={form} />}
    </Formik>
  );
};

export default EduBudgetRequestFormContainer;
